import React from 'react';
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

export interface TimeSeriesPoint {
  date: string;
  visits: number;
  leads: number;
}

interface Props {
  data: TimeSeriesPoint[];
}

export default function PilotTimeSeriesChart({data}: Props) {
  return (
    <ResponsiveContainer width="100%" height={260}>
      <AreaChart data={data} margin={{top: 8, right: 16, bottom: 0, left: -8}}>
        <defs>
          <linearGradient id="pilot-visits-grad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#3b82f6" stopOpacity={0.35} />
            <stop offset="100%" stopColor="#3b82f6" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="pilot-leads-grad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#5f7a32" stopOpacity={0.45} />
            <stop offset="100%" stopColor="#5f7a32" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
        <XAxis dataKey="date" tick={{fontSize: 12}} />
        <YAxis tick={{fontSize: 12}} allowDecimals={false} />
        <Tooltip
          contentStyle={{
            fontSize: 12,
            borderRadius: 8,
            border: '1px solid rgba(0,0,0,0.08)',
          }}
        />
        <Legend wrapperStyle={{fontSize: 12}} />
        <Area
          type="monotone"
          dataKey="visits"
          stroke="#3b82f6"
          fill="url(#pilot-visits-grad)"
          name="Visits"
        />
        <Area
          type="monotone"
          dataKey="leads"
          stroke="#5f7a32"
          fill="url(#pilot-leads-grad)"
          name="Leads"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
